import { render, staticRenderFns } from "./ConfirmeCustomer.vue?vue&type=template&id=bc1ef136"
import script from "./ConfirmeCustomer.vue?vue&type=script&lang=js"
export * from "./ConfirmeCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports